import i18n, { initI18n, setLocale } from '@link/share/i18n';
import shareLangEn from '@link/share/i18n/lang/en';
import shareLangJa from '@link/share/i18n/lang/ja';
import shareLangKo from '@link/share/i18n/lang/ko';
import shareLangZh from '@link/share/i18n/lang/zh';
import shareLangZt from '@link/share/i18n/lang/zt';
import en from './lang/en';
import ja from './lang/ja';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';

initI18n({
  enText: {
    views: {
      faq: shareLangEn.faq,
      privacy: shareLangEn.privacy,
      terms: shareLangEn.terms,
      booking: shareLangEn.booking,
      bookResult: shareLangEn.bookResult,
      ...en.views
    }
  },
  jaText: {
    views: {
      faq: shareLangJa.faq,
      privacy: shareLangJa.privacy,
      terms: shareLangJa.terms,
      booking: shareLangJa.booking,
      bookResult: shareLangJa.bookResult,
      ...ja.views
    }
  },
  koText: {
    views: {
      faq: shareLangKo.faq,
      privacy: shareLangKo.privacy,
      terms: shareLangKo.terms,
      booking: shareLangKo.booking,
      bookResult: shareLangKo.bookResult,
      ...ko.views
    }
  },
  zhText: {
    views: {
      faq: shareLangZh.faq,
      privacy: shareLangZh.privacy,
      terms: shareLangZh.terms,
      booking: shareLangZh.booking,
      bookResult: shareLangZh.bookResult,
      ...zh.views
    }
  },
  ztText: {
    views: {
      faq: shareLangZt.faq,
      privacy: shareLangZt.privacy,
      terms: shareLangZt.terms,
      booking: shareLangZt.booking,
      bookResult: shareLangZt.bookResult,
      ...zt.views
    }
  }
});

export { setLocale };

export default i18n;
